module.exports = __webpack_public_path__ + "static/media/bg-onions.39d27fc7.jpg";